import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface ExpedienteResumen {
    titulo: string;
    estado: string;
    polizaNumero: string;
    expedienteNumero: string;
    eventYear: string;
    fechaOcurrencia: string;
    /**
     * Si el NIF del asegurado del expediente (ASEGURADO de Innova) coincide con el del usuario
     * logado. Lo resuelve el backend en EventDTO.isInsuredInEvent, igual que el "Quiero..." del
     * historial de partes y que el listado de expedientes; aqui solo se transporta para decidir
     * que acciones se ofrecen. El NIF del asegurado, al ser dato de un tercero, no viaja.
     */
    esAseguradoEnExpediente: boolean;
}

@Component({
    selector: 'app-cases',
    templateUrl: './cases.component.html',
    styleUrls: ['./cases.component.scss']
})
export class CasesComponent {

    @Input() expedientes: ExpedienteResumen[] = [];
    @Input() loading: boolean = false;

    skeletonSlots: number[] = [0, 1, 2];

    constructor(private router: Router) {}

    get items(): ExpedienteResumen[] {
        return (this.expedientes || []).slice(0, 3);
    }

    irA(link: string): void {
        this.router.navigate([link]);
    }

    /**
     * Solo el asegurado del expediente puede ver el detalle y escribir al tramitador. Ante la
     * duda (dato ausente) se oculta: es preferible que un tomador legitimo tenga que llamar a
     * que alguien vea un expediente de otra persona.
     */
    puedeOperar(expediente: ExpedienteResumen): boolean {
        return !!expediente && expediente.esAseguradoEnExpediente === true;
    }

    irDetalle(expediente: ExpedienteResumen): void {
        // Guarda defensiva: la plantilla ya oculta los botones, pero la navegacion no debe
        // depender solo de eso.
        if (!this.puedeOperar(expediente)) { return; }
        const ruta = this.eventRoute(expediente);
        this.router.navigate(ruta || ['/events']);
    }

    irTramitador(expediente: ExpedienteResumen): void {
        if (!this.puedeOperar(expediente)) { return; }
        const ruta = this.eventRoute(expediente);
        this.router.navigate(ruta ? ruta.concat(['messenger']) : ['/contact/form']);
    }

    private eventRoute(expediente: ExpedienteResumen): any[] | null {
        const ref = (expediente && expediente.expedienteNumero || '').toString().trim();
        if (!ref) { return null; }
        return ['/event', ref];
    }

    tagClass(estado: string): string {
        const e = (estado || '').toLowerCase();
        if (e === 'cerrado') return 'tag-cerrado';
        if (e === 'abierto') return 'tag-abierto';
        return 'tag-en-curso';
    }
}
